import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { NavigationService } from 'app/services/navigation.service';
import { AxthenticationService } from '../services/axthentication.service';


@Injectable({
  providedIn: 'root'
})
export class AxthGuard implements CanActivate, CanActivateChild {
    constructor(private authService: AxthenticationService,
        private navigationService: NavigationService,
        private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // alert('isLoggedIn====' + this.authService.isLoggedIn + ',' + this.router.url);
        let url: string = state.url;
        let returnValue: boolean = this.checkLogin(url);

        //console.log('>>>>>>> returnValue : ' + returnValue);
        //console.log('>>>>>>> this.navigationService.backClicked : ' + this.navigationService.backClicked + ',url=' + url);

        if (this.navigationService.backClicked) {
            this.navigationService.backClicked = false;
            try {
                history.pushState(null, '', location.href)
            } catch (e) { }
            return false;
        }

        return returnValue;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        let returnValue: boolean = this.canActivate(route, state);

        // console.log('>>>>>>> returnValue : ' + returnValue);
        //console.log('>>>>>>> this.navigationService.backClicked : ' + this.navigationService.backClicked);

        if (this.navigationService.backClicked) {
            this.navigationService.backClicked = false;
            try {
                history.pushState(null, '', location.href)
            } catch (e) { }
            return false;
        }

        return returnValue;
    }

    checkLogin(url: string): boolean {

        if (this.authService.isLoggedIn) {
            return true;
        }

        if (url.indexOf('/cot') > -1) {
            if (!this.authService.isInitPage) {
                return true;
            }
        }

        // if (url.indexOf('/cot/ccmotlgin/ccmotlginhome') > -1) {
        //     if (!this.authService.isInitPage) {
        //        return true;
        //    }
        // }

        if (url.indexOf('homeContent:cotSubPageCode') > -1) {
            return true;
        }

        // PIB 轉置成功頁面
        // if (url.indexOf('/cot/chkotptog/chkotptoghome') > -1) {
        //     if (!this.authService.isInitPage) {
        //        return true;
        //    }
        // }

        // PIB 轉置錯誤頁面
        // if (url.indexOf('/cot/chkotptog/chkotptogfail') > -1) {
        //    if (!this.authService.isInitPage) {
        //        return true;
        //    }
        // }

        // Store the attempted URL for redirecting
        this.authService.redirectUrl = url;
        // Navigate to the login page with extras
        // this.router.navigate(['/cot','ccmotlgin','ccmotlginhome']);
        this.router.navigate(['/init']);

        return false;
    }
}
